'use strict';

export const TODAY = 'TODAY';

export const DATE_HEADER = 'DATE_HEADER';

export function groupByDate({dateGetter, dateFormatter, filter}) {
  return function groupByDate(list) {
    const today = dateFormatter(new Date().getTime());
    let currentDate = 0;
    let id = 0;
    const result = [];
    list.forEach(model => {
      if (filter && !filter(model)) {
        return;
      }

      const displayDate = dateGetter(model);
      if (currentDate !== displayDate) {
        currentDate = displayDate;

        if (currentDate === today) {
          result.push(makeSubHeader(TODAY, id++));
        } else {
          result.push(makeSubHeader(currentDate, id++));
        }
      }
      result.push(model);
    });
    return result;
  };
}

function makeSubHeader(date, id) {
  return {
    type: DATE_HEADER,
    id: `DATE_HEADER${id}`,
    date: date,
  };
}



// WEBPACK FOOTER //
// ./src/js/components/lists/DateHeader/utils.js